/**
 * GuitarFinds — Brand Logo Marquee
 * Keeps motion preferences and Theme Editor lifecycle clean.
 */
(function () {
  'use strict';

  class BrandMarquee {
    constructor(el) {
      this.el = el;
      this.track = el.querySelector('.gf-marquee__track');
      this.abortController = new AbortController();
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onReducedMotionChange = () => this.applyMotionPreference();

      if (!this.track) return;

      this.reducedMotion.addEventListener('change', this.onReducedMotionChange, {
        signal: this.abortController.signal
      });

      this.el.addEventListener('focusin', () => this.el.classList.add('is-paused'), {
        signal: this.abortController.signal
      });

      this.el.addEventListener('focusout', () => this.applyMotionPreference(), {
        signal: this.abortController.signal
      });

      this.applyMotionPreference();
    }

    applyMotionPreference() {
      this.el.classList.toggle('is-paused', this.reducedMotion.matches);
    }

    destroy() {
      this.abortController.abort();
      this.reducedMotion.removeEventListener('change', this.onReducedMotionChange);
    }
  }

  function init(root = document) {
    root.querySelectorAll('[data-brand-marquee]').forEach((el) => {
      if (!el._brandMarquee) el._brandMarquee = new BrandMarquee(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));

  document.addEventListener('shopify:section:unload', (event) => {
    const el = event.target.querySelector('[data-brand-marquee]');
    if (!el?._brandMarquee) return;
    el._brandMarquee.destroy();
    delete el._brandMarquee;
  });
})();
